import React, {useState, useEffect, useContext} from 'react';
import Section from '../UI/Section';
import {Context} from '../../context';
import {
  dollarAmount,
  getDateString,
  getPaymentMethodIcon
} from '../../helperFunctions';
import LoadingSpinner from '../UI/LoadingSpinner';

function SingleOrderHistory() {
  const {fetchSingleOrderDetails, localeText, getTicketName, content} =
    useContext(Context);
  const [singleOrderDetails, setSingleOrderDetails] = useState(null);
  const [orderId] = useState(window.location.href.split('/').slice(-1));

  useEffect(() => {
    fetchSingleOrderDetails(+orderId).then(res => {
      setSingleOrderDetails(res);
    });
  }, [fetchSingleOrderDetails, setSingleOrderDetails, orderId]);

  return singleOrderDetails ? (
    <div>
      <table>
        <tbody>
          <tr>
            <th className='text-left'>
              {localeText('rw_title_order_date', 'Order Date')}
            </th>
            <td className='pl-4'>
              {singleOrderDetails && getDateString(singleOrderDetails.created)}
            </td>
          </tr>
          <tr>
            <th className='text-left'>
              {localeText('rw_title_order_number', 'Order Number')}
            </th>
            <td className='pl-4'>{orderId}</td>
          </tr>
          <tr>
            <th className='text-left'>
              {localeText('rw_title_payment_method', 'Payment Method')}
            </th>
            <td className='pl-4'>
              <div className='flex flex-col'>
                {singleOrderDetails.paymentInfo.map((paymentInfo, index) => {
                  if (paymentInfo?.processor === 'courtesy') {
                    return (
                      <p key={index}>
                        {localeText(
                          'rw_msg_courtesy_transaction',
                          'This was a courtesy transaction and no payment information is available.'
                        )}
                      </p>
                    );
                  }
                  const paymentMethodSrc = getPaymentMethodIcon(
                    content,
                    paymentInfo
                  );
                  return (
                    <div key={index} className='flex items-center gap-4'>
                      {paymentMethodSrc && (
                        <img
                          alt={localeText(
                            'rw_alt_payment_method_icon',
                            'Payment method icon'
                          )}
                          src={paymentMethodSrc}
                          className='h-8 w-12'
                        />
                      )}
                      **** {paymentInfo.last4}
                    </div>
                  );
                })}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className='w-fit'>
        <Section
          heading={localeText('rw_header_items', 'Items')}
          className='mt-8 w-fit'
        >
          <table>
            <tbody>
              <tr>
                <th className='text-left pb-2'>
                  {localeText('rw_title_description', 'Description')}
                </th>
                <th className='text-left pl-4'>QTY</th>
                <th className='text-left pl-4'>
                  {localeText('rw_title_price', 'Price')}
                </th>
              </tr>
              {singleOrderDetails &&
                singleOrderDetails.lineItems.map((lineItem, index) => (
                  <tr key={index}>
                    <td className=''>{getTicketName(lineItem.productId)}</td>
                    <td className='pl-4'>{lineItem.qty}</td>
                    <td className='pl-4'>{dollarAmount(lineItem.price)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div className='mt-2 flex flex-row justify-end text-xl font-bold '>
            <div className='pt-3 border-t border-gray-400 pr-4 '>
              {localeText('rw_title_total', 'Total')}:
            </div>
            <div className='pt-3 border-t border-gray-400'>
              {singleOrderDetails &&
                dollarAmount(singleOrderDetails?.paymentInfo[0]?.amount)}
            </div>
          </div>
        </Section>
      </div>
    </div>
  ) : (
    <LoadingSpinner />
  );
}

export default SingleOrderHistory;
